import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=3ea4db7e&"
import script from "./Preview.vue?vue&type=script&lang=js&"
export * from "./Preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea4db7e')) {
      api.createRecord('3ea4db7e', component.options)
    } else {
      api.reload('3ea4db7e', component.options)
    }
    module.hot.accept("./Preview.vue?vue&type=template&id=3ea4db7e&", function () {
      api.rerender('3ea4db7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/Preview.vue"
export default component.exports